import { render, staticRenderFns } from "./StaticContentHomePageCard.vue?vue&type=template&id=8a295e14"
import script from "./StaticContentHomePageCard.vue?vue&type=script&lang=js"
export * from "./StaticContentHomePageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports